import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ErrorState, Loading, Spinner } from "@/components/States";

export default function AcceptInvite() {
  const { token } = useParams();
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [invite, setInvite] = useState(null);
  const [loadErr, setLoadErr] = useState("");
  const [form, setForm] = useState({ name: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/invites/token/${token}`).then((r) => { setInvite(r.data); setForm((f) => ({ ...f, name: r.data.name || "" })); })
      .catch((e) => setLoadErr(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      const { data } = await api.post(`/invites/token/${token}/accept`, form);
      signIn(data); nav("/");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout eyebrow="You're invited" title={invite?.workspace_name ? `Join ${invite.workspace_name}` : "Join the team"}>
      {loadErr ? <ErrorState message={loadErr} /> : !invite ? <Loading rows={2} /> : (
        <form onSubmit={submit} className="space-y-5" data-testid="accept-invite-form">
          <p className="text-sm text-muted-foreground" data-testid="invite-details">
            Creating a <span className="font-semibold capitalize text-foreground">{invite.role}</span> account for <span className="font-semibold text-foreground">{invite.email}</span>.
          </p>
          <div className="space-y-2"><Label htmlFor="inv-name">Your name</Label>
            <Input id="inv-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="invite-name-input" /></div>
          <div className="space-y-2"><Label htmlFor="inv-pw">Password (8+ characters)</Label>
            <Input id="inv-pw" type="password" minLength={8} required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="invite-password-input" /></div>
          {error && <p role="alert" className="text-sm text-destructive" data-testid="invite-error">{error}</p>}
          <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="invite-submit-button">{busy && <Spinner />} Create account</Button>
        </form>
      )}
    </AuthLayout>
  );
}
